import { useRef } from "react";
import { FormattedMessage as FM } from "react-intl";
import { XMarkIcon } from "components/Icons";
import { cn } from "tools/ui";

const BASE_STYLE =
  "grow z-40 shadow-lg bg-neutral-100 max-h-max! rounded-lg mx-auto my-auto ring-none overflow-y-hidden scroll-style backdrop:bg-stone-900/50";
const BASE_STYLE_HEADER =
  "flex justify-between sticky top-0 bg-neutral-100 z-10 pt-2";
const dialogSize = "w-screen md:w-3/5";

export function CustomModal({
  openModal,
  handleClose,
  handleAccept,
  children,
  title,
  size,
  styleChild,
  style,
}) {
  const ref = useRef(null);
  const size_ = size ?? dialogSize;

  function onClose() {
    openModal.value = false;
    ref.current?.close();
    if (handleClose) {
      handleClose();
    }
  }

  function onAccept() {
    if (handleAccept) {
      handleAccept();
    }
  }

  return (
    <dialog
      ref={ref}
      open={openModal?.value}
      className={cn(BASE_STYLE, style, size_)}
      onCancel={onClose}
    >
      <div className="flex flex-col h-full px-3 md:px-5 overflow-visible scroll-style">
        <div className={BASE_STYLE_HEADER}>
          {title ? (
            <h1 className="text-neutral-800 text-3xl my-auto">
              <FM id={title} key={title} />
            </h1>
          ) : (
            <span />
          )}
          <button
            type="button"
            className="ml-auto hover:bg-neutral-200 rounded-full relative cursor-pointer active:scale-95"
            onClick={onClose}
          >
            <XMarkIcon className="fill-current text-neutral-500 hover:text-rose-500 active:text-blue-300 w-8" />
          </button>
        </div>
        <div
          className={cn(
            "w-full h-auto relative overflow-y-auto pb-20",
            styleChild,
          )}
        >
          {children}
        </div>
      </div>
    </dialog>
  );
}
